module.exports = __webpack_public_path__ + "static/media/yellowhead-7.f0cd19fd.jpg";